/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */
import _ from 'lodash';
import React from 'react';

import { Grid, Form, Header, Divider } from '@mairistem/composants';
import type {
  Diplome,
  Individu,
  Profession,
  Sexe,
  SituationScolaire,
  Specialite,
} from '@/types';
import PanelButtonEdition from '../PanelButtonEdition';
import InformationsComplementairesModal from './InformationsComplementairesModal';

interface InformationsComplementairesPanelProps {
  situationScolaire: SituationScolaire;
  diplome: Diplome;
  specialite: Specialite;
  profession: Profession;
  identifiantNationaliteBis: number;
  sexe: Sexe;
  scolarise: boolean;
  activiteProfessionnelle: boolean;
  updated: boolean;
  recense: Partial<Individu>;
  onChange: (data: Partial<Individu>) => void;
  onSave: () => Promise<void>;
  onRollback: () => void;
}

const InformationsComplementairesPanel = (
  props: InformationsComplementairesPanelProps,
) => {
  const {
    situationScolaire,
    diplome,
    specialite,
    profession,
    sexe,
    identifiantNationaliteBis,
    scolarise,
    activiteProfessionnelle,
    updated,
    recense,
    onChange,
    onSave,
    onRollback,
  } = props;

  const [modalEditionOpen, setModalEditionOpen] =
    React.useState<boolean>(false);

  const handleClose = React.useCallback(() => {
    setModalEditionOpen(false);
  }, []);

  const handleCancel = React.useCallback(() => {
    onRollback();
    handleClose();
  }, [handleClose, onRollback]);

  return (
    <Grid as={Form}>
      <Grid.Row>
        <Header as="h5" color="blue" style={{ margin: 0 }}>
          QUALIFICATIONS
        </Header>
        <PanelButtonEdition
          onClick={() => {
            setModalEditionOpen(true);
          }}
          data-testid="panel-edit-modal-infocomp"
        />
        {modalEditionOpen && (
          <InformationsComplementairesModal
            diplome={diplome}
            situationScolaire={situationScolaire}
            specialite={specialite}
            profession={profession}
            sexe={sexe}
            identifiantNationaliteBis={identifiantNationaliteBis}
            scolarise={scolarise}
            activiteProfessionnelle={activiteProfessionnelle}
            updated={updated}
            onChange={onChange}
            onSave={onSave}
            onClose={handleClose}
            onCancel={handleCancel}
          />
        )}
      </Grid.Row>
      <Grid.Row>
        <Grid.Column
          mobile={16}
          tablet={8}
          computer={8}
          largeScreen={4}
          widescreen={4}
        >
          <span>
            <b>Situation scolaire : </b>
          </span>
          <span>
            {recense?.situationScolaire?.libelle || (scolarise ? 'Oui' : 'Non')}
          </span>
        </Grid.Column>
        <Grid.Column
          mobile={16}
          tablet={8}
          computer={8}
          largeScreen={4}
          widescreen={4}
        >
          <span>
            <b>Diplômes : </b>
          </span>
          <span>{recense?.diplome?.libelle || 'Non renseigné'}</span>
        </Grid.Column>
        <Grid.Column
          mobile={16}
          tablet={8}
          computer={8}
          largeScreen={4}
          widescreen={4}
        >
          <span>
            <b>Spécialité : </b>
          </span>
          <span>{recense?.specialite?.libelle || 'Non renseigné'}</span>
        </Grid.Column>
        <Grid.Column
          mobile={16}
          tablet={8}
          computer={8}
          largeScreen={4}
          widescreen={4}
        >
          <span>
            <b>Profession : </b>
          </span>
          <span>
            {recense?.profession?.libelle ||
              (activiteProfessionnelle ? 'Oui' : 'Non')}
          </span>
        </Grid.Column>
      </Grid.Row>
      <Divider />
      <Grid.Row>
        <Header as="h5" color="blue" style={{ margin: 0 }}>
          NATIONALITE
        </Header>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column
          mobile={16}
          tablet={8}
          computer={8}
          largeScreen={4}
          widescreen={4}
        >
          <span>
            <b>Bénéficie d&apos;une double nationalité : </b>
          </span>
          <span>{recense?.identifiantNationaliteBis ? 'Oui' : 'Non'}</span>
        </Grid.Column>
        {!_.isNil(recense?.identifiantNationaliteBis) && (
          <Grid.Column
            mobile={16}
            tablet={8}
            computer={8}
            largeScreen={4}
            widescreen={4}
          >
            <span>
              <b>2ème nationalité : </b>
            </span>
            <span>{recense?.nationaliteBis?.nationaliteFeminin || '-'}</span>
          </Grid.Column>
        )}
      </Grid.Row>
    </Grid>
  );
};

export default InformationsComplementairesPanel;
